const accountApiRoot: string | undefined = import.meta.env.REACT_APP_BASE_API_URL

export async function getSalesConditions(langCode: string): Promise<string> {
	const response = await fetch(accountApiRoot + `/api/content/salesConditions?lang=${langCode}`);
	if (response.ok) {
		const data = await response.text();
		return data;
	} else {
		throw new Error("Could not get sales conditions");
	}
}

export async function getMaintenanceStatus(): Promise<boolean> {
	try {
		const response = await fetch(accountApiRoot + "/api/settings/maintenance");
		if (response.ok) {
			const data: { result: boolean; isSuccess: boolean } = await response.json();
			return data.result || !data.isSuccess;
		}
	} catch {
		// fail open — treat network errors as not in maintenance
	}
	return false;
}

export async function getApprovedCountries(): Promise<string[]> {
	try {
		const response = await fetch(accountApiRoot + "/api/settings/approvedCountries");
		if (response.ok) {
			const data: { result: string[]; isSuccess: boolean } = await response.json();
			return data.isSuccess ? data.result ?? [] : [];
		}
	} catch {
		// fail open — an empty list means all countries are allowed
	}
	return [];
}
